import { AnimatePresence, motion } from "framer-motion"
import React, { useEffect, useState } from "react"

import Icons from "../Icon/icon"
import { SidebarDimmer } from "../Sidebar/sidebar"
import animeprops from "../animations"
import { setAppError } from "../../refactored-functions/state"
import useError from "../../refactored-functions/hooks/error"

export const errorer = data => {
  data.confirmBtn = data.confirmBtn || ""
  const updated = setAppError(data)
}
if (typeof window !== "undefined") {
  window._errorer = errorer
}
export const alerter = () => {
  console.log("launch alert dialog")
}
export const confirmer = () => {
  console.log("launch confirm dialog")
}

const ModalDialog = () => {
  const [error, setError] = useError()
  const [active, setActive] = useState(false)
  const [info, setInfo] = useState({})

  useEffect(() => {
    if (error.message && error.ui === "modal") {
      const { message, title, code, confirmBtn } = error
      setInfo({
        message,
        code,
        title: title || "Error",
        confirmBtn,
      })
      setActive(true)
    } else {
      setActive(false)
    }
  }, [error])

  return (
    <AnimatePresence>
      {active && (
        <>
          <motion.div
            className="fixed z-40 inset-0 bg-black opacity-75"
            exit={{ opacity: 0 }}
          />
          <motion.div
            className="fixed z-40 inset-0 flex justify-center bg-transparent w-screen"
            {...animeprops["y-spring-100"]}
            exit={{ opacity: 0 }}
          >
            <div className="fixed z-50 w-11/12 lg:w-6/12 max-w-main-container shadow-none lg:shadow-main top-50 bg-white rounded-lg">
              <div
                className="flex justify-end pt-4 pr-4 text-2xl text-gray-500 cursor-pointer"
                onClick={() => setError(null)}
              >
                <Icons fa="times" />
              </div>
              <div className="flex flex-col pt-0 pb-8 px-8 text-gray-800">
                <div className="text-2xl font-bold leading-snug mb-4">
                  {info.title}
                </div>
                <div className="text-lg leading-snug">{info.message}</div>
                {info.confirmBtn && (
                  <div className="flex justify-center">
                    <motion.button
                      className="w-56 text-lg bg-primary-normal text-white py-3 font-bold rounded-30 mt-4"
                      onClick={() => setError(null)}
                    >
                      {info.confirmBtn}
                    </motion.button>
                  </div>
                )}
                {info.code && (
                  <div className="pt-8 text-small text-gray-500 font-bold">
                    ⚠️ Error code: {info.code}
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default ModalDialog
